(function ($) {
  'use strict';

  let defaultOptions = {
    minLength: 15,
    maxLength: 100,
    label: 'Texto Alternativo'
  };

  let HELP_CLASS = 'tbw-required-alt-help';

  function helpText(o) {
    return 'O texto alternativo tem que ficar entre ' + o.minLength + ' e ' + o.maxLength + ' caracteres';
  }

  function errorText(o, length) {
    return 'O texto alternativo deve ter entre ' + o.minLength + ' e ' + o.maxLength +
           ' caracteres (' + length + ' atual)';
  }

  // Torna o campo `alt` obrigatorio usando o contrato de validacao que o proprio
  // openModalInsert ja expoe: `field.pattern` + `field.patternError`
  // (node_modules/trumbowyg/dist/trumbowyg.js, dentro do handler de confirm do modal).
  //
  // Nao usamos `required: true` de proposito: o core trata `required` antes do
  // `pattern` e mostra `t.lang.required` ("Required", em ingles, pois nao
  // configuramos `lang` no editor). Com apenas `pattern`, campo vazio e campo
  // curto caem na mesma mensagem em pt-BR.
  function enforceAlt(field, o) {
    field.label = o.label;
    field.attributes = $.extend({ maxlength: o.maxLength }, field.attributes || {});
    field.pattern = {
      test: function (value) {
        let length = (value || '').length;
        field.patternError = errorText(o, length);
        return length >= o.minLength && length <= o.maxLength;
      }
    };
  }

  function addHelpText($modal, o) {
    let $altInput = $('input[name="alt"]', $modal);
    if ($altInput.length === 0 || $altInput.next('.' + HELP_CLASS).length > 0) return;

    $altInput.after($('<small/>', {
      class: HELP_CLASS,
      text: helpText(o),
      style: 'display:block; margin-top:2px; color:#666;'
    }));
  }

  $.extend(true, $.trumbowyg, {
    plugins: {
      requiredAlt: {
        init: function (trumbowyg) {
          trumbowyg.o.plugins.requiredAlt =
            $.extend(true, {}, defaultOptions, trumbowyg.o.plugins.requiredAlt || {});

          let options = trumbowyg.o.plugins.requiredAlt,
              originalOpenModalInsert = trumbowyg.openModalInsert;

          trumbowyg.openModalInsert = function (title, fields, callback) { // eslint-disable-line no-unused-vars
            // Modal sem campo de texto alternativo (ex.: createLink), ou campo que
            // ja declara `required: true` (ex.: figcaption, que ja tem a propria
            // validacao e o proprio texto de ajuda): nada a fazer, nao duplicar.
            if (!fields || !fields.alt || fields.alt.required === true) {
              return originalOpenModalInsert.apply(this, arguments);
            }

            try {
              enforceAlt(fields.alt, options);
            } catch (e) {} // eslint-disable-line no-empty

            let $modal = originalOpenModalInsert.apply(this, arguments);

            try {
              if ($modal) addHelpText($modal, options);
            } catch (e) {} // eslint-disable-line no-empty

            return $modal;
          };
        }
      }
    }
  });
})(jQuery);
